import React from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';


function CustomMessage(props) {
    const setClose = () => {
        props.close();
    }

   

    return (
        <Modal
            centered={false}
            size="mini"
            open={props.open}
            onClose={() => setClose()}
        >
            <Modal.Content>
                <p>{props.message}</p>
            </Modal.Content>
            <Modal.Actions>
                <Button primary onClick={() => setClose()}>
                    Ok
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default CustomMessage;
